import { useState } from "react";
/**
 * Hook pour gérer la pagination des heatmaps dans les graphiques de qualité
 */
export const useQualityChartSelections = () => {
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [weeksPageLabel, setWeeksPageLabel] = useState("");

  const weeksPerPage = 10;

  return {
    currentPage,
    setCurrentPage,
    totalPages,
    setTotalPages,
    weeksPageLabel,
    setWeeksPageLabel,
    weeksPerPage,
  };
};
